import { lazy } from 'react';

// Components
import { RouteObject } from '@spazious/dollhouse-router';
import {
  // Components
  Features,
  Main,
  RootBoundary,
  // Constants
  ROUTE_PATH_DECORATIONS,
  ROUTE_PATH_DEVTOOLS,
  ROUTE_PATH_FARRANGEMENTS,
  ROUTE_PATH_FURNITURES,
  ROUTE_PATH_INSPECTOR,
  ROUTE_PATH_REAL_TIME_SHARING,
  ROUTE_PATH_RECORDER,
  ROUTE_PATH_ROOT,
  ROUTE_PATH_SETUP_TEMPLATES,
  ROUTE_PATH_SHARE,
} from '@spazious/dollhouse-shared';

// Lazy loaded components
const FurnituresPanel = lazy(async () => {
  const { FurnituresPanel } = await import('@spazious/dollhouse-shared/FurnituresPanel');
  return { default: FurnituresPanel };
});

const FArrangementsPanel = lazy(async () => {
  const { FArrangementsPanel } = await import('@spazious/dollhouse-shared/FArrangementsPanel');
  return { default: FArrangementsPanel };
});

const DecorationsPanel = lazy(async () => {
  const { DecorationsPanel } = await import('@spazious/dollhouse-shared/DecorationsPanel');
  return { default: DecorationsPanel };
});

const TemplatesPanel = lazy(async () => {
  const { TemplatesPanel } = await import('@spazious/dollhouse-shared/TemplatesPanel');
  return { default: TemplatesPanel };
});

const SharePanel = lazy(async () => {
  const { SharePanel } = await import('@spazious/dollhouse-shared/SharePanel');
  return { default: SharePanel };
});

const RealTimeSharingPanel = lazy(async () => {
  const { RealTimeSharingPanel } = await import('@spazious/dollhouse-shared/RealTimeSharingPanel');
  return { default: RealTimeSharingPanel };
});

const RecorderPanel = lazy(async () => {
  const { RecorderPanel } = await import('@spazious/dollhouse-shared/RecorderPanel');
  return { default: RecorderPanel };
});

const InspectorPanel = lazy(async () => {
  const { InspectorPanel } = await import('@spazious/dollhouse-shared/InspectorPanel');
  return { default: InspectorPanel };
});

const DevToolsPanel = lazy(async () => {
  const { DevToolsPanel } = await import('@spazious/dollhouse-shared/DevToolsPanel');
  return { default: DevToolsPanel };
});

/**
 * Routes for the application
 */
export const routes: RouteObject[] = [
  {
    path: ROUTE_PATH_ROOT,
    element: <Main />,
    errorElement: <RootBoundary />,
    children: [
      {
        path: ROUTE_PATH_FURNITURES,
        element: (
          <Features features={['furnitures', 'fensembles']}>
            <FurnituresPanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_SETUP_TEMPLATES,
        element: (
          <Features features="templates">
            <TemplatesPanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_FARRANGEMENTS,
        element: (
          <Features features="farrangements">
            <FArrangementsPanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_DECORATIONS,
        element: (
          <Features features="decorations">
            <DecorationsPanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_SHARE,
        element: (
          <Features features="share">
            <SharePanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_REAL_TIME_SHARING,
        element: (
          <Features features="real-time-sharing">
            <RealTimeSharingPanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_RECORDER,
        element: (
          <Features features="records">
            <RecorderPanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_INSPECTOR,
        element: (
          <Features features="inspector">
            <InspectorPanel />
          </Features>
        ),
      },
      {
        path: ROUTE_PATH_DEVTOOLS,
        element: (
          <Features features="devtools">
            <DevToolsPanel />
          </Features>
        ),
      },
    ],
  },
];

export default routes;
